import { Button, Form, Input, Modal, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import React, { useState } from 'react';
import { changeadministratior } from '../../../../api/api';
import './index.css'
const EditorMember = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form]=useForm()
  const { setIsFresh } = props
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    form.validateFields().then(
      res=>{
        console.log(res);
        let payload = {
          nickname: form.getFieldValue('nickname'),
          username: form.getFieldValue('username'),
          authority: form.getFieldValue('authority'),
          id:props.info.id
        }
        // console.log(payload);
        changeadministratior(payload).then((res) => {
          console.log(res)
          setIsFresh((pre) => !pre)
        })
        setIsModalOpen(false)
      }
    )
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };
  const {nickname,username,authority}=props.info
  return (
    <>
      <a onClick={showModal}>编辑</a>
      <Modal
        title="修改成员信息"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 18,
          }}
          form={form}
          initialValues={{
            nickname: nickname,
            username: username,
            authority: authority,
          }}
        >
          <Form.Item
            rules={[
              {
                required: true,
                message: '请输入昵称！',
              },
            ]}
            label="昵称"
            name="nickname"
          >
            <Input style={{ width: '330px' }} />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: '请输入用户名！',
              },
            ]}
            label="用户名"
            name="username"
          >
            <Input style={{ width: '330px' }} />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: '请输入角色！',
              },
            ]}
            label="角色"
            name="authority"
          >
            <Select
              placeholder="请选择"
              style={{ textAlign: 'left' }}
              mode="multiple"
              defaultValue={authority}
            >
              <Select.Option value={1}>超级管理员</Select.Option>
              <Select.Option value={2}>管理员</Select.Option>
              <Select.Option value={3}>审核员</Select.Option>
              <Select.Option value={4}>房源管理员</Select.Option>
              <Select.Option value={5}>内容管理员</Select.Option>
              <Select.Option value={6}>活动管理员</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
};
export default EditorMember;